<script>
    import {Link} from "svelte-routing";

    import ProjectsBar from "../ProjectsBar.svelte";
    import ResearchersBar from '../ResearchersBar.svelte';
    import Tag from '../Tag.svelte';

    import Fa from 'svelte-fa'
    import {faExternalLinkAlt, faHome, faUsers, faCogs, faPlayCircle} from '@fortawesome/free-solid-svg-icons'

    const cards = [
        { icon: faPlayCircle, title: "Take the Virtual Tour", to: "tour"},
        { icon: faCogs, title: "Discover the Projects", to: "projects" },
        { icon: faUsers, title: "Meet the Researchers", to: "researchers"},
    ]

</script>
<style>
    .nav-orange{
        color: #004f9e;
        background-color: white;
        text-decoration: none;
    }
</style>
<main>
    <!--<Video video="{'file': 'Summary.mp4'}"/>-->

    <div class="row">
        <h1 class="qualiperf">QualiPerf - FOR 5151</h1>
        <h2 class="qualiperf"><strong>Quantifying Liver Perfusion-Function Relationship in Complex Resection –
            A Systems Medicine Approach</strong>
        </h2>
    </div>
    <div class="row">
        {#each cards as card}
            <div class="col s12 m4 l4">
                <Link  to="{card.to}">
                    <div class="card card-project">
                        <div class="card-content">
                            <Fa class="nav-orange" icon={card.icon} size="7x" />
                            <h2 class="qualiperf">{card.title}</h2>
                        </div>
                    </div>
                </Link>
            </div>
        {/each}
    </div>
    <div class="row">

        <div class="col s12 m12 l6">
            <a href="dfg.de/" target="_blank"><img src="/content/images/dfg_logo_schriftzug_blau_foerderung_en.jpg" height="120" alt="DFG logo"/></a>
        </div>
        <div class="col s12 m12 l6">
            <h3 class="qualiperf">
            This work was supported by the <strong>German Research Foundation (DFG)</strong> within the Research Unit Programme FOR 5151 QuaLiPerF by <strong>grant number 436883643</strong>.
            </h3>
        </div>
    </div>

    <!--
    <div class="row">
        <ResearchersBar />
    </div>
    <div class="row">
        <div class="col s12">
            <Tag tag="Experiments"/>
            <Tag tag="Modeling"/>
            <Tag tag="Data integration"/>
            <Tag tag="Clinics"/>
        </div>
    </div>
    <div class="row">
        <ProjectsBar />
    </div>
    -->





    <!--
    <div class="row">
        <Video id="P4"/>
    </div>
    -->

</main>

